import { mergeLabels } from "@grandvisionhq/state";
import { resilientFetch } from "@grandvisionhq/utils";
import { createBloomreachResourceUrl } from "../../utils/utils/create-resource-url.js";
import { userAgentHeader } from "../../utils/utils/http-client.js";
import { flattenResources } from "../../utils/utils/flatten-resources.js";
const fetch = resilientFetch();
async function getLabels(apiUrl, channel, resourceIds, locale) {
  const url = createBloomreachResourceUrl(apiUrl, channel, resourceIds, locale.replace("-", "_"));
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { Accept: "application/json", "User-Agent": userAgentHeader }
    });
    if (!response.ok) {
      throw new Error(`received ${response.status} from Bloomreach`);
    }
    const resources = await response.json();
    const labelSets = flattenResources(resources);
    return mergeLabels(labelSets);
  } catch (err) {
    console.error(`Error while fetching labels for ${url}`, err);
  }
}
export {
  getLabels
};
//# sourceMappingURL=get-labels.js.map
